import NearByProductHorizontalList from './NearByProductHorizontalList'

export default NearByProductHorizontalList
